import React from 'react';
import { ThemeContext } from '@fluentui/react-theme-provider';
import { FundTableMin } from '../tables/FundTableMin';
import * as L from '../Styles/FundDetailStyles';
import * as S from '../Styles/FundDetailsUnavailableFallbackStyles';

export interface FundFamilyFallbackSectionProps
{
    fundGroups: any[]
}

export const FundFamilyFallbackSection: React.FunctionComponent<FundFamilyFallbackSectionProps> = (props: FundFamilyFallbackSectionProps) =>
{
    const theme = React.useContext(ThemeContext);

    if(!props.fundGroups?.length)
    {
        return null;
    }

    return(
        <S.ActionsSection>
            <div id="fund-family-fallback">
                <S.FamilyTitle>Más clases ({props.fundGroups.length})</S.FamilyTitle>
                <L.FundBrothersContainer theme={theme}>
                    <FundTableMin children={props.fundGroups} onRowClicked={() => { }} />
                </L.FundBrothersContainer>
            </div>
        </S.ActionsSection>
    );
};